import { useContext } from "react";
import Context from "../../../context";

import DownloadPageSection from "../Layout/DownloadPageSection";

export default function BillsUsageDownload({ setSubPage }) {
  const { contextState, setContextState } = useContext(Context);

  let account = contextState.currentAccount;

  return (
    <>
      <DownloadPageSection accounts={account} />
    </>
  );
}
